class BESSAppCouncilSettings extends BESSAppBase {

    constructor() {
        super();
        this.root = $('.app-council-settings');
        if (this.root.length === 0) return;
        this.councilName = $('.app-selected-council').text();

        this.councilSelector = $('#id_active_council');
        this.councilSelector.change(this.#onCouncilChanged.bind(this));

        $('.app-remove-council-user').bindClickEvent(this, this.#onRemoveCouncilUser);

        this.lookupUserEmail = getMaterialTextControl('lookup_user_email');
        this.addCouncilUserBtn = $('.app-council-add-user-btn');
        this.lookupUserEmail.typeahead({
            minLength: 3,
        }, {
            source: this.#onLookupUserEmail.bind(this),
        }).bind('typeahead:select', this.#onSelectUserEmail.bind(this));
        this.addCouncilUserBtn.bindClickEvent(this, this.#onAddCouncilUser);

        new BESSAppCouncilAttributes();
    }

    #onCouncilChanged() {
        let councilId = this.councilSelector.val();
        window.location.href = window.location.href.split('?')[0] + '?council_id=' + councilId;
    }

    #onRemoveCouncilUser(e) {
        let link = $(e.target);
        let name = link.parents('tr').find('td:first-child').text();
        let userId = link.attr('data-user-id');
        this.askUserToConfirmSeriousOperation("Remove Council User",
            "Remove " + name + " from " + this.councilName + " Council Users?",
            function () {
                this.showDoingWork("Remove Council User", "Removing " + name + " from " + this.councilName + " Council Users");
                BESSApp.instance.services.api.council.removeCouncilUser(userId, function () {
                    window.location.reload();
                });
            }.bind(this)
        );
    }

    #onLookupUserEmail(userEmail, syncResults, asyncResults) {
        BESSApp.instance.services.api.council.lookupAddCouncilUserEmail(userEmail, function (results) {
            let userDataMap = {};
            let names = _.map(results, function (x) {
                userDataMap[x.display] = x;
                return x.display;
            });
            this.userDataMap = userDataMap;
            asyncResults(names);
        }.bind(this));
    }

    #onSelectUserEmail() {
        this.addCouncilUserBtn.enableControl(true);
        this.lookupUserEmail.blur();
        let emailVal = this.lookupUserEmail.val();
        this.addCouncilUserData = this.userDataMap[emailVal];
    }

    #onAddCouncilUser() {
        this.showDoingWork('Adding Council User', "Adding " + this.addCouncilUserData['display'] + " to " + this.councilName);
        BESSApp.instance.services.api.council.addCouncilUser(this.addCouncilUserData['id'], function () {
            window.location.reload();
        });
    }
}